import styles from "./Switch.module.css";
import { FunctionComponent } from "react";
import classNames from "classnames";

type TProps = {
  value: boolean;
  disabled?: boolean;
  onChange: () => void;
};

const Switch: FunctionComponent<TProps> = (props) => (
  <label className={styles.switch}>
    <input
      type={styles.checkbox}
      checked={true}
      readOnly
      data-component="Switch"
    />
    <span
      className={classNames(styles.slider, {
        [styles.checked]: props.value,
        [styles.disabled]: props.disabled,
      })}
      onClick={props.onChange}
    ></span>
  </label>
);

export default Switch;
